import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router'
import { RankingsService } from '../rankings.service'
import { Observable, of } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { getIdFromSlug } from 'src/app/shared/utility-functions/slug.utility'

/**
 * tabs resolver class to make the event-detail only load itself and
 * its routes only after the getting of the event is resolved
 */
@Injectable()
export class RankingResolver implements Resolve<{}> {
  constructor(private rankingsService: RankingsService) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const id = getIdFromSlug(route.params.slug)
    return this.rankingsService.getRanking(id).pipe(catchError(err => of({})))
  }
}
